export const listOfRoutes = (builder) => ({
    listOfRoutes: builder.mutation({
      query: ({ pageNumber, limit, user_name, comm_type }) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/get_list_of_routes',
          method: 'GET',
          params: { pageNumber, limit, user_name, comm_type },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  